:host {
  display: inline-flex;
  width: auto;
  height: auto;
  align-self: flex-end;
}

:host([disabled]) {
  opacity: 0.3;
  pointer-events: none;
  cursor: default;
}
